import { NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PageLayout } from './page';
import {
  ButtonModule,
  FooterLinkModule,
  FooterModule,
  HeaderModule,
  IconModule,
  PageLoaderModule,
  PageModule,
  SocialLinkModule,
  TopBarModule,
  UspLinkModule,
} from '@unive/ui';

@NgModule({
  declarations: [PageLayout],
  exports: [PageLayout],
  imports: [
    PageModule,
    RouterOutlet,
    TopBarModule,
    UspLinkModule,
    HeaderModule,
    ButtonModule,
    FooterModule,
    FooterLinkModule,
    IconModule,
    SocialLinkModule,
    NgIf,
    PageLoaderModule,
  ],
})
export class LayoutModule {}
